export { default } from './FixedPreviewPanel';
